import api from "@/api/axiosApi";

import handleHttpError from "@/util/HttpErrorHandler";
const API_URL = `/section_content`;

const allSectionContent = async (sectionDataId) => {
  const url = `${API_URL}/section/${sectionDataId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching section Content:", error);
    handleHttpError(
      error,
  "Erreur lors du chargement du contenu de section (par ID)."
    );

    return [];
  }
};
export const allSectionContentByPosition = async (sectionDataId) => {
  const url = `${API_URL}/section_position/${sectionDataId}`;

  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching section Content:", error);
    handleHttpError(
      error,
  "Erreur lors du chargement du contenu de section par position."
    );

    return [];
  }
};

const saveSectionContent = async (sectionContentData) => {
  try {
    const response = await api.post(API_URL, sectionContentData);

    return response.data;
  } catch (error) {
    console.error(
  "Erreur lors de l'enregistrement du contenu de section.",
      error
    );
    handleHttpError(
      error,
  "Erreur lors de l'enregistrement du contenu de section.",
    );

    throw error;
  }
};
export const getIdSectionContent = async (sectionContentId) => {
  const url = `${API_URL}/${sectionContentId}`;
  try {
    await api.get(url);
  } catch (error) {
    console.error("Erreur lors de la recuperation du section Content :", error);
    handleHttpError(
      error,
      "Erreur lors de la récupération du composant Model Somme Content par Id"
    );

    throw error;
  }
};

export const updateSectionContent = async (
  sectionContentId,
  sectionContentData
) => {
  const url = `${API_URL}/${sectionContentId}`;
  try {
    const response = await api.put(url, sectionContentData);
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour  de la section Content  :",
      error
    );
    handleHttpError(
      error,
  "Erreur lors de la mise à jour du contenu de section."
    );

    throw error;
  }
};

export const deleteSectionContent = async (sectionContentId) => {
  const url = `${API_URL}/${sectionContentId}`;
  try {
    await api.delete(url);
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de la section Content :",
      error
    );
    handleHttpError(
      error,
  "Erreur lors de la suppression du contenu de section."
    );

    throw error;
  }
};
export { saveSectionContent, allSectionContent };
